import { atom, selector } from 'recoil';

import { GetConsultationsRequest, GetStatisticsRequest } from 'api';
import {
  filterAssigneeState,
  filterAuthorityState,
  filterCategoryState,
  filterConsultationTypeState,
  filterDateFromState,
  filterDateToState,
  filterStatusState,
  filterTeamState,
} from './filter';
import { searchSortState } from './sort';
import { filterArchiveRequestState } from './filterArchiveRequestState';
import { searchViewTypeState } from './searchViewTypeState';

export const searchAssignedToMeState = atom<boolean>({
  key: 'searchAssignedToMe',
  default: true,
});

export const searchTextState = atom<string>({
  key: 'searchText',
  default: '',
});

export const searchPageNumberState = atom<number>({
  key: 'searchPageNumber',
  default: 1,
});

export const searchPageSizeState = atom<number>({
  key: 'searchPageSize',
  default: 10,
});

export const searchAtoms = [
  searchViewTypeState,
  searchAssignedToMeState,
  searchTextState,
  searchPageNumberState,
  searchPageSizeState,
];

export const searchRequestState = selector<GetConsultationsRequest>({
  key: 'searchRequest',
  get: ({ get }) => {
    const dateFrom = get(filterDateFromState);
    const dateTo = get(filterDateToState);

    return {
      ...get(filterArchiveRequestState),
      assignedToMe: get(searchAssignedToMeState),
      assigneeIds: get(filterAssigneeState).map((assignee) => assignee.value),
      authorityIds: get(filterAuthorityState).map((authority) => authority.value),
      categoryIds: get(filterCategoryState).map((category) => category.value),
      statusIds: get(filterStatusState).map((status) => status.value),
      teamIds: get(filterTeamState).map((team) => team.value),
      ...(dateFrom ? { dateFrom: dateFrom.toISOString() } : null),
      ...(dateTo ? { dateTo: dateTo.toISOString() } : null),
      typeIds: get(filterConsultationTypeState).map((type) => type.value),
      ...(get(searchTextState) ? { searchText: get(searchTextState) } : null),
      sortOptionId: get(searchSortState),
      pageSize: get(searchPageSizeState),
      pageNumber: get(searchPageNumberState),
    };
  },
});

export const statisticsRequestState = selector<GetStatisticsRequest>({
  key: 'statisticsRequest',
  get: ({ get }) => ({
    ...get(filterArchiveRequestState),
    statusIds: get(filterStatusState).map((status) => status.value),
  }),
});
